export default __webpack_public_path__ + "static/media/aws-logo.515ae7a1.svg";